import { createCRUDHook } from './createCRUDHook';
import { StoreSectionColorDto } from 'utils/models';
import { ECG_STORE_SECTION_COLOR_IMAGE } from './apiEndPoints';

const { Context, useManager, useConsumer } =
  createCRUDHook<StoreSectionColorDto>({
    entityName: 'StoreSectionColorImage',
    endpoint: ECG_STORE_SECTION_COLOR_IMAGE,
  });

export const StoreSectionColorImageContext = Context;
export const useStoreSectionColorImageManager = useManager;
export const useStoreSectionColorImage = useConsumer;
